import React, { useState, useEffect } from 'react';
import * as S from './styles';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { JOB_DETAILS_UI } from '../TranslationValues';
import { fetchBatchDetails } from '../../../../../utils/services/statusMonitoringAPI';
import { message } from 'antd';

const NAMESPACES = ['JOB_DETAILS_UI', 'STATUS_MONITORING'];

const JobDetailsTab = ({ batch, users, isDraft = false, t }) => {
  const batchTypeMap = {
    STANDARD: { key: 'STANDARD_LABEL', value: 'QUICK' },
    ADVANCED: { key: 'ADVANCED_LABEL', value: 'STANDARD' },
    HYBRID: { key: 'HYBRID_LABEL', value: 'Hybrid' },
    API: {key: 'API_LABEL', value: 'API'}
  };

  const channelMap = {
    PRINT: { key: 'CHANNEL_DOCUMENT', value: 'Documents' },
    EMAIL: { key: 'CHANNEL_EMAIL', value: 'Email' },
    MESSAGES: { key: 'CHANNEL_MESSAGES', value: 'Messages' },
  };

  const initiatedFromMap = {
    DRAFT_UPLOAD: { key: 'Design_Systems', value: 'Design Systems'},
    LIVE_UPLOAD: { key: 'BATCH_STUDIO', value: 'Batch Studio'},
    LIVE_API: { key: 'LIVE_API', value: 'API'},
    QA_UPLOAD: { key: 'QA_UPLOAD', value: 'QA Upload'},
  }

  const [batchDetails, setBatchDetails] = useState();

  const getBatchDetails = async () => {
    try {
      const response = await fetchBatchDetails(batch?.id, batch?.batchType === 'HYBRID');
      if (response?.statusCode === 7039) {
        setBatchDetails(response?.data);
        return;
      } else {
        message.error(t(JOB_DETAILS_UI.FETCH_DETAILS_ERROR.key, JOB_DETAILS_UI.FETCH_DETAILS_ERROR.value));
      }
    } catch (error) {
      console.error("Failed to fetch batch details:", error);
      message.error(t(JOB_DETAILS_UI.FETCH_DETAILS_ERROR.key, JOB_DETAILS_UI.FETCH_DETAILS_ERROR.value));
    }
  };

  useEffect(() => {
    if (batch?.id) {
      getBatchDetails();
    }
  }, [batch?.id]);

  const triggeredUserName = users?.find(u => Number(u?.id) === Number(batch?.triggeredBy))?.displayName;
  const approverUserName = users?.find(u => Number(u?.id) === Number(batch?.approver))?.displayName;


  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
      <div>
        <S.CardHeader>{isDraft ? t(JOB_DETAILS_UI.SAVED_DETAILS.key, JOB_DETAILS_UI.SAVED_DETAILS.value) : t(JOB_DETAILS_UI.BASIC_JOB_INFO.key, JOB_DETAILS_UI.BASIC_JOB_INFO.value)}</S.CardHeader>
        <S.DetailsGrid>
          {/* <S.DetailItem>
                        <S.DetailLabel>Batch Name</S.DetailLabel>
                        <S.DetailValue>{batch?.batchName}</S.DetailValue>
                    </S.DetailItem> */}
          {batch?.batchType && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.JOB_TYPE.key, JOB_DETAILS_UI.JOB_TYPE.value)}</S.DetailLabel>
              <S.DetailValue>
                {batchTypeMap[batch.batchType]
                  ? t(batchTypeMap[batch.batchType].key, batchTypeMap[batch.batchType].value)
                  : batch.batchType}
              </S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.channelType && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.DELIVERY_CHANNEL.key, JOB_DETAILS_UI.DELIVERY_CHANNEL.value)}</S.DetailLabel>
              <S.DetailValue>
                {channelMap[batch.channelType.toUpperCase()]
                  ? t(channelMap[batch.channelType.toUpperCase()].key, channelMap[batch.channelType.toUpperCase()].value)
                  : batch.channelType.charAt(0).toUpperCase() + batch.channelType.slice(1).toLowerCase()}
              </S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.createdTime && (
            <>
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.CREATED_DATE.key, JOB_DETAILS_UI.CREATED_DATE.value)}</S.DetailLabel>
                <S.DetailValue>{moment(batch.createdTime).format('Do MMM YYYY')}</S.DetailValue>
              </S.DetailItem>
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.CREATED_TIME.key, JOB_DETAILS_UI.CREATED_TIME.value)}</S.DetailLabel>
                <S.DetailValue>{moment(batch.createdTime).format('h:mm A')}</S.DetailValue>
              </S.DetailItem>
            </>
          )}
          {
            batch?.communicationName && batch?.batchType !== 'HYBRID' && (
              <S.DetailItem>
                <S.DetailLabel>{batch?.channelType === 'multiChannel' ? t(JOB_DETAILS_UI.COMMUNICATION.key, JOB_DETAILS_UI.COMMUNICATION.value) : t(JOB_DETAILS_UI.TEMPLATE.key, JOB_DETAILS_UI.TEMPLATE.value)}</S.DetailLabel>
                <S.DetailValue>
                  {batch?.communicationName}
                </S.DetailValue>
              </S.DetailItem>
            )
          }
          {
            batch?.fileName && batch?.batchType !== 'HYBRID' && (
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.DATA_FILE_NAME.key, JOB_DETAILS_UI.DATA_FILE_NAME.value)}</S.DetailLabel>
                <S.DetailValue>
                  {batch?.fileName}
                </S.DetailValue>
              </S.DetailItem>
            )
          }
          {
            batch?.batchType !== 'HYBRID' && batchDetails?.categoryName && (
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.TEMPLATE_CATEGORY.key, JOB_DETAILS_UI.TEMPLATE_CATEGORY.value)}</S.DetailLabel>
                <S.DetailValue>
                  {batchDetails?.categoryName}
                </S.DetailValue>
              </S.DetailItem>
            )
          }
          {batch?.splitType && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.SPLIT_CRITERIA.key, JOB_DETAILS_UI.SPLIT_CRITERIA.value)}</S.DetailLabel>
              <S.DetailValue>{batch.splitType === 'address' ? t(JOB_DETAILS_UI.ADDRESS.key, JOB_DETAILS_UI.ADDRESS.value) : t(JOB_DETAILS_UI.PAGE_COUNT.key, JOB_DETAILS_UI.PAGE_COUNT.value)}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.envelopeType && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.ENVELOPE_TYPE.key, JOB_DETAILS_UI.ENVELOPE_TYPE.value)}</S.DetailLabel>
              <S.DetailValue>{batch.envelopeType}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.batchType === 'HYBRID' && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.STATIONARY_NAME.key, JOB_DETAILS_UI.STATIONARY_NAME.value)}</S.DetailLabel>
              <S.DetailValue>{batchDetails?.stationaryName}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.batchType === 'HYBRID' && batchDetails?.insertsName && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.INSERT_NAME.key, JOB_DETAILS_UI.INSERT_NAME.value)}</S.DetailLabel>
              <S.DetailValue>{batchDetails?.insertsName}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.deliveryClass && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.DELIVERY_CLASS.key, JOB_DETAILS_UI.DELIVERY_CLASS.value)}</S.DetailLabel>
              <S.DetailValue>{batch.deliveryClass}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.totalCount !== undefined && batch?.totalCount !== null && (
            <S.DetailItem>
              <S.DetailLabel>{batch?.batchType === 'HYBRID' ? t(JOB_DETAILS_UI.LETTER_COUNT.key, JOB_DETAILS_UI.LETTER_COUNT.value) : t(JOB_DETAILS_UI.RECORD_COUNT.key, JOB_DETAILS_UI.RECORD_COUNT.value)}</S.DetailLabel>
              <S.DetailValue>{batch.totalCount}</S.DetailValue>
            </S.DetailItem>
          )}
          {batch?.dataFile && (
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.DATA_FILE.key, JOB_DETAILS_UI.DATA_FILE.value)}</S.DetailLabel>
              <S.DetailValue>{batch.dataFile}</S.DetailValue>
            </S.DetailItem>
          )}
        </S.DetailsGrid>
      </div>

      {/* Job Specific Details */}
      {batch?.initiatedFrom && (
        <div style={{ paddingTop: '1.5rem', borderTop: '1px solid #e5e7eb' }}>
          <h4
            style={{ fontSize: '1rem', fontWeight: 700, color: '#1f2937', marginBottom: '0.75rem' }}
          >
            {t(JOB_DETAILS_UI.ADDITIONAL_DETAILS.key, JOB_DETAILS_UI.ADDITIONAL_DETAILS.value)}
          </h4>
          <S.DetailsGrid>
            {batch?.initiatedFrom && (
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.INITIATED_FROM.key, JOB_DETAILS_UI.INITIATED_FROM.value)}</S.DetailLabel>
                <S.DetailValue>
                  {t(initiatedFromMap[batch.initiatedFrom].key, initiatedFromMap[batch.initiatedFrom].value)}
                </S.DetailValue>
              </S.DetailItem>
            )}

            {(batch?.triggeredBy !== undefined && triggeredUserName) && (
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.INITIATED_BY.key, JOB_DETAILS_UI.INITIATED_BY.value)}</S.DetailLabel>
                <S.DetailValue>{triggeredUserName}</S.DetailValue>
              </S.DetailItem>
            )}

            {(batch?.approver && approverUserName && batch?.approvalType !== 'LEVEL') && (
              <S.DetailItem>
                <S.DetailLabel>{t(JOB_DETAILS_UI.APPROVER_LABEL.key, JOB_DETAILS_UI.APPROVER_LABEL.value)}</S.DetailLabel>
                <S.DetailValue>{approverUserName}</S.DetailValue>
              </S.DetailItem>
            )}
          </S.DetailsGrid>
        </div>
      )}

      {(batch?.batchType === 'ADVANCED' || batch?.batchType === 'HYBRID') && batch?.processingType === 'SCHEDULED' && batch?.scheduledTime && (
        <div style={{ paddingTop: '1.5rem', borderTop: '1px solid #e5e7eb' }}>
          <h4
            style={{ fontSize: '1rem', fontWeight: 700, color: '#1f2937', marginBottom: '0.75rem' }}
          >
            {t(JOB_DETAILS_UI.SCHEDULE_CONFIGURATION.key, JOB_DETAILS_UI.SCHEDULE_CONFIGURATION.value)}
          </h4>
          <S.DetailsGrid>
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.SCHEDULED_DATE.key, JOB_DETAILS_UI.SCHEDULED_DATE.value)}</S.DetailLabel>
              <S.DetailValue>{moment(batch?.scheduledTime).format('Do MMM YYYY')}</S.DetailValue>
            </S.DetailItem>
            <S.DetailItem>
              <S.DetailLabel>{t(JOB_DETAILS_UI.SCHEDULED_TIME.key, JOB_DETAILS_UI.SCHEDULED_TIME.value)}</S.DetailLabel>
              <S.DetailValue>{moment(batch?.scheduledTime).format('h:mm A')}</S.DetailValue>
            </S.DetailItem>
          </S.DetailsGrid>
        </div>
      )}
    </div>
  );
};

export default withTranslation(NAMESPACES)(JobDetailsTab);
